import { nocturneClubTemplate } from "./nocturneClub";
import type { SiteTemplateDefinition } from "../types";

export const restaurantNightBarTemplate: SiteTemplateDefinition = {
    manifest: {
        ...nocturneClubTemplate.manifest,
        code: "restaurant-night-bar",
        name: "Bar & noční podnik",
        category: "restaurant",
        description: "Temná obrazová šablona pro bary, cocktail bary a večerní podniky s programem, nápojovým lístkem a rezervacemi.",
        previewImage: "/templates/restaurant-night-bar/preview.webp",
    },
    render: (props) => (
        <div data-web-template="restaurant-night-bar">
            {nocturneClubTemplate.render(props)}
        </div>
    ),
};
